import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { EEventType } from '../../../../types/events';
import { EKeyCode } from '../../../../types/keyCodes';
import { ETwoFactorType } from '../../../../types/authentication';
import { ERequestStatus } from '../../../../types/requestStatus';
import { ContentLayout } from '../../../../components/ContentLayout';
import { PhoneField } from '../../../../components/PhoneField';
import { EActiveView } from '../../../../types/view';
import { trackTwoFactorClose, trackTwoFactorContinueClick, trackTwoFactorPhoneInputClick } from '../../../../utils/tracking';
import { FormFieldGroupLayout } from '../../../../components/FieldGroupLayout';
import { sendCodeMultichannel, changePhone, changeAutosubmit } from '../../../../actions/twoFactorPhone';
import { changeLogin } from '../../../../actions/login';
import { changeView } from '../../../../actions/view';
import { reset } from '../../../../actions/authentication';
import { emit } from '../../../../actions/events';
import { isSubmitDisabledSelector, loginSelector, phoneErrorSelector, phoneSelector, twoFactorStatusSelector, isPhoneInvalidSelector, isAutosubmitEnabledSelector } from './selectors';
import { selectAutoFocusDisabled } from '../../../../selectors/autoFocusDisabled';
import { isPhone } from '../../../../utils/validation';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var FormContainer = function FormContainer(_ref) {
  var useSelector = _ref.useSelector,
    useDispatch = _ref.useDispatch;
  var dispatch = useDispatch();
  var login = useSelector(loginSelector);
  var phone = useSelector(phoneSelector);
  var twoFactorStatus = useSelector(twoFactorStatusSelector);
  var isSubmitDisabled = useSelector(isSubmitDisabledSelector);
  var isAutosubmitEnabled = useSelector(isAutosubmitEnabledSelector);
  var phoneError = useSelector(phoneErrorSelector);
  var autoFocusDisabled = useSelector(selectAutoFocusDisabled);
  var isPhoneInvalid = useSelector(isPhoneInvalidSelector);

  // FORM
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isChanged = _React$useState2[0],
    setIsChanged = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isTouched = _React$useState4[0],
    setIsTouched = _React$useState4[1];

  // PHONE
  var phoneRef = React.useRef(null);
  var handlePhoneChange = React.useCallback(function (value) {
    var newValue = value.replace(/\s/gi, '');
    dispatch(changePhone(newValue));
    setIsChanged(true);
  }, [dispatch]);

  // SUBMIT
  var handleSubmit = React.useCallback(function () {
    trackTwoFactorContinueClick(ETwoFactorType.Phone);
    setIsTouched(true);
    if (isSubmitDisabled) {
      return;
    }
    if (isPhoneInvalid) {
      if (phoneRef.current) {
        phoneRef.current.focus();
      }
      return;
    }
    dispatch(sendCodeMultichannel());
    setIsChanged(false);
    dispatch(emit(EEventType.TwoFactorContinueClick));
  }, [dispatch, isSubmitDisabled, isPhoneInvalid]);
  React.useEffect(function () {
    if (isPhone(phone) && isAutosubmitEnabled) {
      handleSubmit();
      dispatch(changeAutosubmit(false));
    }
  }, [dispatch, phone, isAutosubmitEnabled, handleSubmit]);
  var handleBackClick = React.useCallback(function () {
    trackTwoFactorClose(ETwoFactorType.Phone);
    dispatch(reset());
    dispatch(changeLogin(login));
    dispatch(changeView(EActiveView.AuthenticationRegistration));
  }, [dispatch, login]);
  var handlePreventSubmit = React.useCallback(function (e) {
    e.preventDefault();
  }, []);
  var handleSubmitOnEnter = React.useCallback(function (e) {
    if (e.keyCode === EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  return /*#__PURE__*/_jsx(ContentLayout, {
    children: /*#__PURE__*/_jsx("form", {
      onSubmit: handlePreventSubmit,
      children: /*#__PURE__*/_jsx(FormFieldGroupLayout, {
        content: /*#__PURE__*/_jsx(PhoneField, {
          autoComplete: "tel",
          autoFocus: !autoFocusDisabled,
          inputRef: phoneRef,
          name: "phone",
          id: "two_factor-phone",
          value: phone,
          onFocus: trackTwoFactorPhoneInputClick,
          errorMessage: twoFactorStatus === ERequestStatus.Failed && !isChanged ? phoneError : undefined,
          invalid: isTouched && (twoFactorStatus === ERequestStatus.Failed && !isChanged || isPhoneInvalid),
          disabled: isSubmitDisabled,
          onKeyDown: handleSubmitOnEnter,
          onValueChange: handlePhoneChange
        }),
        buttons: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Button, {
            "data-name": "ResumeTwoFactorBtn",
            theme: "fill_primary",
            fullWidth: true,
            loading: isSubmitDisabled,
            disabled: isSubmitDisabled,
            onClick: handleSubmit,
            children: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C"
          }), /*#__PURE__*/_jsx(Button, {
            "data-name": "CancelTwoFactorBtn",
            theme: "fill_secondary",
            fullWidth: true,
            onClick: handleBackClick,
            children: "\u041E\u0442\u043C\u0435\u043D\u0430"
          })]
        })
      })
    })
  });
};